import React, { useState, useRef, useEffect } from 'react';

export const Search: React.FunctionComponent = () => {
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState<string[]>([]);
  const [searchLat, setSearchLat] = useState<number | string>('');
  const [searchLng, setSearchLng] = useState<number | string>('');
  const searchFormRef = useRef<HTMLFormElement>(null);
  const inputCityRef = useRef<HTMLInputElement>(null);
  const submitLocationRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (inputCityRef.current) {
      const autocompleteCityFetch = async (cityName: string) => {
        // const url = 'https://www.speisekarte.de/ajax/form/autocomplete/city/name';
        const url = 'https://skde.bplaced.net/proxy/portal/autocomplete.php';
        const options = {
          method: 'POST',
          headers: { 'content-type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({ input: cityName })
        };

        try {
          const response = await fetch(url, options);
          const data = await response.json();
          setCities(data.countryList);
        } catch (error) {
          console.error(error);
        }
      };

      inputCityRef.current.addEventListener('keyup', event => {
        const target = event.target as HTMLInputElement;
        autocompleteCityFetch(target.value);
      });
    }

    if (submitLocationRef.current && navigator.geolocation) {
      const geolocation = (callback: { (): void; (): void }) => {
        setLoading(true);

        const handleSuccess = (position: {
          coords: {
            latitude: React.SetStateAction<number>;
            longitude: React.SetStateAction<number>;
          };
        }) => {
          if (inputCityRef.current) {
            inputCityRef.current.value = 'Mein Standort';
          }
          setSearchLat(position.coords.latitude);
          setSearchLng(position.coords.longitude);

          if (callback) {
            callback();
          }
        };

        const handleError = (error: { message: React.SetStateAction<string> }) => {
          console.error(error.message);
          setLoading(false);
        };

        const options = {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        };
        navigator.geolocation.getCurrentPosition(handleSuccess, handleError, options);
      };

      submitLocationRef.current.addEventListener('click', async event => {
        event.preventDefault();
        geolocation(() => {
          if (searchFormRef.current) {
            searchFormRef.current.submit();
          }
        });
      });
    }
  }, []);

  return (
    <div className="relative isolate bg-black">
      <picture>
        <source srcSet="https://www.speisekarte.de/images/search-bg.webp" type="image/webp" />
        <source srcSet="https://www.speisekarte.de/images/search-bg.jpg" type="image/jpeg" />
        <img
          src="https://www.speisekarte.de/images/search-bg.jpg"
          alt="Suche Hintergrundbild"
          className="absolute inset-0 -z-10 h-full w-full object-cover opacity-40"
        />
      </picture>
      <form
        className="relative inset-0 h-full w-full items-center px-7 py-20 text-center"
        action="https://www.speisekarte.de/restaurantsuche"
        method="post"
        encType="multipart/form-data"
        ref={searchFormRef}
      >
        <div className="text-sk-grey-0 mb-8 text-5xl font-medium uppercase">
          Worauf hast Du Lust?
        </div>
        <div className="mx-auto flex w-full max-w-md flex-col gap-3.5">
          <input
            type="text"
            name="search[phrase]"
            placeholder="Was? (Gericht, Zutat, Restaurantname, Küche, ...)"
            className="bg-sk-grey-0 rounded-full p-3.5 text-center"
          />
          <input
            type="text"
            name="search[location]"
            placeholder="Wo? (Ort, Stadtteil oder Postleitzahl) *"
            className="bg-sk-grey-0 rounded-full p-3.5 text-center"
            list="autocompleteCity"
            autoComplete="off"
            required
            ref={inputCityRef}
          />
          <datalist id="autocompleteCity">
            {cities.map(city => (
              <>
                {(city = city.replace(/<\/?b>/g, ''))}
                <option key={city} value={city} />
              </>
            ))}
          </datalist>
          <input
            type="submit"
            name="search[send]"
            value="Suchen"
            className="bg-sk-red-500 text-sk-grey-0 cursor-pointer rounded-full p-3.5 text-center"
          />
          {false && (
            <button
              type="submit"
              name="search[sendGeo]"
              className="bg-sk-grey-900 text-sk-grey-0 relative mt-7 cursor-pointer rounded-full p-3.5 text-center"
              data-busy={loading}
              ref={submitLocationRef}
            >
              In meiner Nähe suchen{' '}
              {loading && (
                <img
                  src="https://www.speisekarte.de/images/icons/location.svg"
                  className="absolute top-1/2 -translate-y-1/2"
                  alt="Standort Icon"
                />
              )}
            </button>
          )}
          <input type="hidden" name="search[lat]" value={searchLat} />
          <input type="hidden" name="search[lng]" value={searchLng} />
          <input type="hidden" name="search[_token]" value="csrf-token" />
        </div>
      </form>
    </div>
  );
};
